export default "__VITE_ASSET__3e0e2bd2__"